import { render, staticRenderFns } from "./StepBar.vue?vue&type=template&id=5478c23e"
import script from "./StepBar.vue?vue&type=script&lang=js"
export * from "./StepBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports